import React from "react";
import {
  Menu,
  List,
  Box,
  Typography,
  Button,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
  Divider,
  MenuItem,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import NotificationTimeLabel from "../../../../components/NotificationTimeLabel";

interface NotificationMenuProps {
  anchorEl: any;
  isOpen: boolean;
  onClose: () => void;
  notifications: any[];
  onViewAll: () => void;
  onNotificationClick: (item: any) => void;
  onMenuOpen: (event: any, item: any) => void;
  menuAnchor: any;
  selectedItem: any;
  onMenuClose: () => void;
  onMarkRead: (item: any) => void;
  onMarkUnread: (item: any) => void;
}

export const NotificationMenu: React.FC<NotificationMenuProps> = React.memo(({
  anchorEl,
  isOpen,
  onClose,
  notifications,
  onViewAll,
  onNotificationClick,
  onMenuOpen,
  menuAnchor,
  selectedItem,
  onMenuClose,
  onMarkRead,
  onMarkUnread,
}) => (
  <>
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={{ top: 60, left: 1895 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          width: 400,
          maxHeight: 400,
          p: 0,
          border: "1px solid #eee",
          borderRadius: "8px",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: "8px 14px", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between" }}>
        <Typography fontWeight={600} sx={{ display: "flex", alignItems: "center" }}>
          Notifications
        </Typography>
        <Button onClick={onViewAll} size="small" variant="text">
          View all
        </Button>
      </Box>

      <List sx={{ maxHeight: 350, overflowY: "auto", overflowX: "hidden" }}>
        {notifications?.length > 0 ? (
          notifications.map((item: any, index: number) => (
            <Box key={index} sx={{ "&:hover": { backgroundColor: "rgba(144, 202, 249, 0.2)" } }}>
              <ListItem
                alignItems="flex-start"
                sx={{
                  cursor: "pointer",
                  p: "0px 14px 0px 6px",
                  "& .MuiListItemAvatar-root": { minWidth: "36px", marginRight: "8px" },
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ width: 32, height: 32 }}>
                    {item?.avatar ? (
                      <img src={`/images/avatars/${item.avatar}`} style={{ width: "100%", height: "100%" }} />
                    ) : (
                      item?.title?.charAt(0)
                    )}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: "12px !important" }}>
                        {item?.tableName === "ReferBookEntry" && "Referral Update"}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                          <MoreHorizIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  }
                  secondary={
                    <Typography
                      variant="caption"
                      sx={{
                        whiteSpace: "pre-line",
                        color: "#000",
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "13px !important",
                      }}
                      onClick={() => onNotificationClick(item)}
                    >
                      {item.notificationData}
                    </Typography>
                  }
                />
              </ListItem>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, pb: 0.8 }}>
                <Box sx={{ width: 12, height: 12 }}>
                  {!item.isRead && (
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#285CDB" }} />
                  )}
                </Box>
                <Typography variant="caption" sx={{ fontSize: "12px !important" }}>
                  {item?.createdDate && <NotificationTimeLabel dateString={item?.createdDate} />}
                </Typography>
              </Box>
              <Divider />
            </Box>
          ))
        ) : (
          <Box p={2} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              No notifications found.
            </Typography>
          </Box>
        )}
      </List>
    </Menu>

    <Menu
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={onMenuClose}
      PaperProps={{ sx: { border: "1px solid #eee" } }}
    >
      {selectedItem?.isRead ? (
        <MenuItem onClick={() => onMarkUnread(selectedItem)}>Mark as Unread</MenuItem>
      ) : (
        <MenuItem onClick={() => onMarkRead(selectedItem)}>Mark as Read</MenuItem>
      )}
    </Menu>
  </>
));

NotificationMenu.displayName = "NotificationMenu";
